import { h, Host } from "@stencil/core";
import datepicker from "js-datepicker";
import state from "../store";
import { exportParts } from "../../common/export-parts";
import { commonClassesNames } from "../../common/classesNames";
export class GxgDatePicker {
    constructor() {
        this.disabled = false;
        this.alwaysShow = false;
        this.value = undefined;
        this.label = undefined;
        this.noWeekends = false;
        this.minDate = undefined;
        this.maxDate = undefined;
        this.maxWidth = "100%";
        this.rtl = false;
    }
    parts = {
        input: "input"
    };
    exportparts;
    valueBeforeDisabled;
    el;
    disabledHandler(newValue) {
        if (newValue === true) {
            this.valueBeforeDisabled = this.value;
            this.value = null;
        }
        else {
            this.value = this.valueBeforeDisabled;
        }
    }
    /**
     * Emits the new selected date
     */
    valueChanged;
    // Whenever `busy` changes, this method will fire.
    watchStateHandler(newValue) {
        this.valueChanged.emit(newValue);
    }
    componentWillLoad() {
        this.attachExportParts();
    }
    attachExportParts = () => {
        const part = this.el.getAttribute("part");
        const exportPartsResult = exportParts(part, this.parts);
        exportPartsResult.length && (this.exportparts = exportPartsResult);
    };
    componentDidLoad() {
        //Reading Direction
        const dirHtml = document
            .getElementsByTagName("html")[0]
            .getAttribute("dir");
        const dirBody = document
            .getElementsByTagName("body")[0]
            .getAttribute("dir");
        if (dirHtml === "rtl" || dirBody === "rtl") {
            this.rtl = true;
        }
        if (this.value !== undefined && this.value !== "") {
            //default/initial date
            const d = new Date(this.value);
            if (Object.prototype.toString.call(d) === "[object Date]") {
                // it is a date
                if (isNaN(d.getTime())) {
                    // d.valueOf() could also work
                    // date is not valid
                }
                else {
                    // date is valid
                }
            }
            else {
                // not a date
            }
        }
        //min date
        const minDate = this.minDate ? new Date(this.minDate) : undefined;
        const minDateYear = minDate?.getFullYear();
        const minDateMonth = minDate?.getMonth();
        const minDateDay = minDate?.getDate();
        //max date
        const maxDate = this.maxDate ? new Date(this.maxDate) : undefined;
        const maxDateYear = maxDate?.getFullYear();
        const maxDateMonth = maxDate?.getMonth();
        const maxDateDay = maxDate?.getDate();
        const pickerSelector = this.el.shadowRoot.querySelector("#date-picker");
        const picker = datepicker(pickerSelector, {
            // Event callbacks.
            onSelect: instance => {
                const newValue = instance.dateSelected;
                this.value = newValue;
            },
            // onShow: instance => {
            // },
            // onHide: instance => {
            // },
            // onMonthChange: instance => {
            // },
            // Customizations.
            formatter: (input, date) => {
                // This will display the date as `1/1/2019`.
                input.value = date.toDateString();
            },
            position: "bl",
            startDay: 1,
            customDays: ["S", "M", "T", "W", "T", "F", "S"],
            customMonths: [
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December"
            ],
            customOverlayMonths: [
                "JAN",
                "FEB",
                "MAR",
                "APR",
                "MAY",
                "JUN",
                "JUL",
                "AUG",
                "SEP",
                "OCT",
                "NOV",
                "DEC"
            ],
            overlayButton: "Go!",
            overlayPlaceholder: "Enter a 4-digit year",
            // Settings.
            alwaysShow: this.alwaysShow,
            //dateSelected: new Date(valueYear, valueMonth, valueDay),
            maxDate: maxDate && new Date(maxDateYear, maxDateMonth, maxDateDay),
            minDate: minDate && new Date(minDateYear, minDateMonth, minDateDay),
            startDate: this.value,
            showAllDates: true,
            // Disabling things.
            noWeekends: this.noWeekends,
            disabler: date => date.getDay() === 2 && date.getMonth() === 9,
            // disabledDates: [new Date(2050, 0, 1), new Date(2050, 0, 3)], // Specific disabled dates.
            disableMobile: true,
            disableYearOverlay: false,
            // ID - be sure to provide a 2nd picker with the same id to create a daterange pair.
            id: "date-picker"
        });
        //picker.setDate(new Date(2099, 0, 1), true);
        picker.calendarContainer.style.setProperty("font-size", "9px");
    }
    render() {
        return (h(Host, { class: {
                rtl: this.rtl,
                large: state.large,
                [commonClassesNames["DISABLED_CLASS"]]: this.disabled
            }, style: {
                maxWidth: this.maxWidth
            }, exportParts: this.exportparts ? this.exportparts : null }, this.label ? h("gxg-label", { class: "label" }, this.label) : null, h("input", { type: "text", id: "date-picker", part: this.parts.input, readOnly: true, class: "form-element" })));
    }
    static get is() { return "gxg-date-picker"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["date-picker.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["date-picker.css"]
        };
    }
    static get properties() {
        return {
            "disabled": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "It disabled the date-picker"
                },
                "attribute": "disabled",
                "reflect": false,
                "defaultValue": "false"
            },
            "alwaysShow": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute makes the date-picker always visible"
                },
                "attribute": "always-show",
                "reflect": false,
                "defaultValue": "false"
            },
            "value": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "DatePickerDate",
                    "resolved": "Date | string",
                    "references": {
                        "DatePickerDate": {
                            "location": "local",
                            "path": "/home/circleci/repo/src/components/date-picker/date-picker.tsx",
                            "id": "src/components/date-picker/date-picker.tsx::DatePickerDate"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "initial date"
                },
                "attribute": "value",
                "reflect": false
            },
            "label": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The datepicker label"
                },
                "attribute": "label",
                "reflect": false,
                "defaultValue": "undefined"
            },
            "noWeekends": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "no weekends available"
                },
                "attribute": "no-weekends",
                "reflect": false,
                "defaultValue": "false"
            },
            "minDate": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "DatePickerDate",
                    "resolved": "Date | string",
                    "references": {
                        "DatePickerDate": {
                            "location": "local",
                            "path": "/home/circleci/repo/src/components/date-picker/date-picker.tsx",
                            "id": "src/components/date-picker/date-picker.tsx::DatePickerDate"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The min. date"
                },
                "attribute": "min-date",
                "reflect": false
            },
            "maxDate": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "DatePickerDate",
                    "resolved": "Date | string",
                    "references": {
                        "DatePickerDate": {
                            "location": "local",
                            "path": "/home/circleci/repo/src/components/date-picker/date-picker.tsx",
                            "id": "src/components/date-picker/date-picker.tsx::DatePickerDate"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The max. date"
                },
                "attribute": "max-date",
                "reflect": false
            },
            "maxWidth": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The max. width"
                },
                "attribute": "max-width",
                "reflect": false,
                "defaultValue": "\"100%\""
            }
        };
    }
    static get states() {
        return {
            "rtl": {}
        };
    }
    static get events() {
        return [{
                "method": "valueChanged",
                "name": "valueChanged",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Emits the new selected date"
                },
                "complexType": {
                    "original": "DatePickerDate",
                    "resolved": "Date | string",
                    "references": {
                        "DatePickerDate": {
                            "location": "local",
                            "path": "/home/circleci/repo/src/components/date-picker/date-picker.tsx",
                            "id": "src/components/date-picker/date-picker.tsx::DatePickerDate"
                        }
                    }
                }
            }];
    }
    static get elementRef() { return "el"; }
    static get watchers() {
        return [{
                "propName": "disabled",
                "methodName": "disabledHandler"
            }, {
                "propName": "value",
                "methodName": "watchStateHandler"
            }];
    }
}
//# sourceMappingURL=date-picker.js.map
